import module from 'colaborador/module'
import template from './template.html'

export class ColaboradorCajaAhorroComponent {
  idProyecto
  idColaborador
  data = []

  constructor (ColaboradorCajaAhorroAportaciones) {
    this.ColaboradorCajaAhorroAportaciones = ColaboradorCajaAhorroAportaciones
  }

  $onInit () {
    this.promise = this.ColaboradorCajaAhorroAportaciones.get(this.idProyecto, this.idColaborador)
    .then(({data}) => (this.data = data))
    .then(() => (this.cargarInformacion()))
  }

  cargarInformacion () {
    this.misAportaciones = this.data.filter(item => item.idProyecto === this.idProyecto)
    this.aportaciones = this.data.filter(item => item.idProyecto !== this.idProyecto)
  }

  eliminar (data) {
    if (data) {
      this.data = this.data.filter(item => item.id !== data.id)
      this.cargarInformacion()
    }
  }
}

module.component('colaboradorCajaAhorro', {
  controller: ColaboradorCajaAhorroComponent,
  template,
  bindings: {
    idProyecto: '<',
    idColaborador: '<',
  },
})



// WEBPACK FOOTER //
// ./src/colaborador/components/cajaAhorro/aportaciones/component.js